/**
 * ABテスト設定オブジェクト
 * @typedef {Object} ABTestConfig
 * @property {string} testName - テスト名
 * @property {number} bPatternRatio - Bパターンの割合（0-100）。bPatternRangeを指定した場合は無視されます。
 * @property {[number, number]} bPatternRange - Bパターンとなる範囲（[start, end]）。指定時はbPatternRatioは不要です。
 * @property {boolean} enable - ABテストを有効にするかどうか
 */

// フッタータブABテストの定義
export const FOOTER_TAB_AB_TEST_NAME = 'FOOTER_TAB_AB_TEST'
export const SEARCH_AND_EVENT_DETAIL_AB_TEST_NAME = 'SEARCH_AND_EVENT_DETAIL'
export const TOP_FV_V3_AB_TEST_NAME = 'TOP_FV_V3_AB_TEST'

/**
 * フッタータブABテスト設定
 * @type {ABTestConfig}
 */
export const FOOTER_TAB_AB_TEST_CONFIG = {
  testName: FOOTER_TAB_AB_TEST_NAME,
  bPatternRatio: 30, // 30% B pattern (非表示), 70% A pattern (表示)
  enable: false
}

export const SEARCH_AND_EVENT_DETAIL_AB_TEST_CONFIG = {
  testName: SEARCH_AND_EVENT_DETAIL_AB_TEST_NAME,
  bPatternRatio: 20,
  enable: false
}

export const EVENT_TITLE_AB_TEST_NAME = 'EVENT_TITLE_AB_TEST'

/**
 * イベントタイトルABテスト設定
 * @type {ABTestConfig}
 */
export const EVENT_TITLE_AB_TEST_CONFIG = {
  testName: EVENT_TITLE_AB_TEST_NAME,
  bPatternRatio: 50, // 50% B pattern (短いタイトル), 50% A pattern (長いタイトル)
  enable: false
}

export const TOP_FV_V3_AB_TEST_CONFIG = {
  testName: TOP_FV_V3_AB_TEST_NAME,
  bPatternRatio: 30, // 30% Bパターン（新機能適用）
  enable: false // テスト有効
}

// 回数券A/Bテストの定義
export const REPEAT_DISCOUNT_AB_TEST_NAME = 'REPEAT_DISCOUNT_AB_TEST'

/**
 * 回数券A/Bテスト設定
 * @type {ABTestConfig}
 */
export const REPEAT_DISCOUNT_AB_TEST_CONFIG = {
  testName: REPEAT_DISCOUNT_AB_TEST_NAME,
  bPatternRatio: 30, // 30% Bパターン（回数券モーダル表示）、70% Aパターン（コントロール：表示なし）
  enable: false // テストを有効にする
}

export const CLS_MONITORING_AB_TEST_NAME = 'CLS_MONITORING_TEST'
export const CLS_MONITORING_AB_TEST_CONFIG = {
  testName: CLS_MONITORING_AB_TEST_NAME,
  bPatternRatio: 10, // 10% B pattern (monitoring enabled)
  enable: true
}

export const TOP_FV_V4_AB_TEST_NAME = 'TOP_FV_V4_AB_TEST'
export const TOP_FV_V4_AB_TEST_CONFIG = {
  testName: TOP_FV_V4_AB_TEST_NAME,
  bPatternRatio: 30, // 30% Bパターン（新KV）、70% Aパターン（現行）
  enable: false // ABテストを有効化（false に変更してテストを無効にできます）
}

/**
 * ISSUE402（こだわり条件）A/Bテスト設定
 * bPatternRangeを指定した場合はbPatternRatioは不要です。
 * 同じtestNameを使うことで、他のABテスト（例: ISSUE395）も同じCookie値で判定できます。
 * @type {ABTestConfig}
 */
export const ISSUE_402_AND_395_AB_TEST_NAME = 'ISSUE_402_AND_395_AB_TEST'

export const ISSUE402_AB_TEST_CONFIG = {
  testName: ISSUE_402_AND_395_AB_TEST_NAME,
  bPatternRange: [33, 65], // 33~65がB群
  enable: false
}

export const ISSUE_442_AB_TEST_NAME = 'ISSUE_442_AB_TEST'

/**
 * ISSUE-442: TBD feature ABテスト設定
 * @type {ABTestConfig}
 */
export const ISSUE_442_AB_TEST_CONFIG = {
  testName: ISSUE_442_AB_TEST_NAME,
  bPatternRatio: 31,
  enable: false
}

// issue-528: ai_recommend_v4 ABテスト設定
export const ISSUE_528_AB_TEST_NAME = 'ISSUE_528_AB_TEST'

/**
 * issue-528: ai_recommend_v4 ABテスト設定
 * A群: 既存ロジック（ai_recommend）
 * B群: 新ロジック（ai_recommend_v4）
 * @type {ABTestConfig}
 */
export const ISSUE_528_AB_TEST_CONFIG = {
  testName: ISSUE_528_AB_TEST_NAME,
  bPatternRatio: 100, // Bパターン全適用（ai_recommend_v4）
  enable: true
}

/**
 * issue-400: 新規来訪者向けクーポンABテスト設定
 */
export const FIRST_VIEW_GUEST_COUPON_AB_TEST_NAME = 'FIRST_VIEW_GUEST_COUPON_AB_TEST'
export const FIRST_VIEW_GUEST_COUPON_AB_TEST_CONFIG = {
  testName: FIRST_VIEW_GUEST_COUPON_AB_TEST_NAME,
  bPatternRatio: 0, // 30% Bパターン（新規訪問クーポンモーダル表示）、70% Aパターン（コントロール：表示なし）
  enable: false // テストを有効にする
}

// Payment flow ABテストの定義（issue-403）
export const ISSUE_403_PAYMENT_FLOW_AB_TEST_NAME = 'ISSUE_403_PAYMENT_FLOW_AB_TEST'

/**
 * Payment flow ABテスト設定
 * Aパターン: 既存の購入フロー（purchase_options → guest_purchases/new）
 * Bパターン: 新しい統合購入フロー（1ページで完結）
 * @type {ABTestConfig}
 */
export const ISSUE_403_PAYMENT_FLOW_AB_TEST_CONFIG = {
  testName: ISSUE_403_PAYMENT_FLOW_AB_TEST_NAME,
  bPatternRatio: 100,
  enable: true // テスト有効化
}

export const ISSUE_465_GUEST_PURCHASE_AB_TEST_NAME = 'ISSUE_465_GUEST_PURCHASE_AB_TEST'
/**
 * @type {ABTestConfig}
 */
export const ISSUE_465_GUEST_PURCHASE_AB_TEST_CONFIG = {
  testName: ISSUE_465_GUEST_PURCHASE_AB_TEST_NAME,
  bPatternRatio: 50,
  enable: false
}

// issue-474: TOP FV並び替え ABテスト設定
export const ISSUE_474_AB_TEST_NAME = 'ISSUE_474_AB_TEST'

export const ISSUE_474_AB_TEST_CONFIG = {
  testName: ISSUE_474_AB_TEST_NAME,
  bPatternRatio: 50, // 50% Bパターン（トップFVのa/b入れ替え）
  enable: false
}

// issue-492: 街コン診断モーダル ABテスト設定
export const ISSUE_492_AB_TEST_NAME = 'ISSUE_492_AB_TEST'

/**
 * issue-492: 街コン診断モーダル ABテスト設定
 * A群: 既存UI（70%）
 * B群: 診断モーダル表示（30%）
 * @type {ABTestConfig}
 */
export const ISSUE_492_AB_TEST_CONFIG = {
  testName: ISSUE_492_AB_TEST_NAME,
  bPatternRatio: 30, // 30% Bパターン（モーダル表示）、70% Aパターン（既存UI）
  enable: false
}

export const ISSUE_492_V2_AB_TEST_NAME = 'ISSUE_492_AB_TEST_V2'

/**
 * issue-492: 街コン診断モーダル ABテスト設定
 * A群: 既存UI（70%）
 * B群: 診断モーダル表示（30%）
 * @type {ABTestConfig}
 */
export const ISSUE_492_V2_AB_TEST_CONFIG = {
  testName: ISSUE_492_V2_AB_TEST_NAME,
  bPatternRatio: 0, // 0% Bパターン（新規バナー）、100% Aパターン（既存バナー）
  enable: true
}

// issue-551: 一覧ページ診断バナー ABテスト設定
export const ISSUE_551_AB_TEST_NAME = 'ISSUE_551_AB_TEST'
export const ISSUE_551_AB_TEST_CONFIG = {
  testName: ISSUE_551_AB_TEST_NAME,
  bPatternRatio: 100,
  enable: true
}

// issue-582: AI検索チャット ABテスト設定
export const ISSUE_582_AI_SEARCH_AB_TEST_NAME = 'ISSUE_582_AI_SEARCH_AB_TEST'

/**
 * issue-582: AI検索チャット ABテスト設定
 * A群: 既存UI（「すぐに出会う」タブ）
 * B群: AIと探すタブ表示
 * @type {ABTestConfig}
 */
export const ISSUE_582_AI_SEARCH_AB_TEST_CONFIG = {
  testName: ISSUE_582_AI_SEARCH_AB_TEST_NAME,
  bPatternRatio: 100, // Bパターン（AIと探すタブ表示）— ABテスト完了、100%適用
  enable: true
}
// issue-622: 段階割引残り枚数表示 ABテスト設定
export const ISSUE_622_AB_TEST_NAME = 'ISSUE_622_AB_TEST'

/**
 * issue-622: 段階割引残り枚数表示 ABテスト設定
 * A群（50%）：従来通りの表示
 * B群（50%）：段階割引チケット残り3枚以下の場合「△先着割引残り〇枚」を表示
 * @type {ABTestConfig}
 */
export const ISSUE_622_AB_TEST_CONFIG = {
  testName: ISSUE_622_AB_TEST_NAME,
  bPatternRatio: 50,
  enable: false
}

// ABテストのレジストリ（全テストをまとめて初期化するために使用）
export const AB_TEST_REGISTRY = [
  ISSUE_465_GUEST_PURCHASE_AB_TEST_CONFIG,
  ISSUE_528_AB_TEST_CONFIG,
  ISSUE_551_AB_TEST_CONFIG,
  ISSUE_622_AB_TEST_CONFIG
]
